'use strict';

var _asyncToGenerator = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _regeneratorRuntime = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncIterator = require("/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var errCode = require('err-code');

var itPeekable = require('it-peekable');

var browserStreamToIt = require('browser-readablestream-to-it');

var all = require('it-all');

var _require = require('./utils'),
    isBytes = _require.isBytes,
    isBlob = _require.isBlob,
    isReadableStream = _require.isReadableStream;
/**
 * @param {import('./normalise-input').ToContent} input
 */


function toBlob(_x) {
  return _toBlob.apply(this, arguments);
}
/**
 * @param {AsyncIterable<BlobPart>|Iterable<BlobPart>} stream
 */


function _toBlob() {
  _toBlob = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
    var peekable, _yield$peekable$peek, value, done;

    return _regeneratorRuntime.wrap(function _callee$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!isBytes(input)) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", new Blob([input]));

          case 2:
            if (!(typeof input === 'string' || input instanceof String)) {
              _context2.next = 4;
              break;
            }

            return _context2.abrupt("return", new Blob([input.toString()]));

          case 4:
            if (!isBlob(input)) {
              _context2.next = 6;
              break;
            }

            return _context2.abrupt("return", input);

          case 6:
            // Browser stream
            if (isReadableStream(input)) {
              input = browserStreamToIt(input);
            } // (Async)Iterator<?>


            if (!(Symbol.iterator in input || Symbol.asyncIterator in input)) {
              _context2.next = 28;
              break;
            }

            /** @type {any} peekable */
            peekable = itPeekable(input);
            /** @type {any} value **/

            _context2.next = 11;
            return peekable.peek();

          case 11:
            _yield$peekable$peek = _context2.sent;
            value = _yield$peekable$peek.value;
            done = _yield$peekable$peek.done;

            if (!done) {
              _context2.next = 16;
              break;
            }

            return _context2.abrupt("return", itToBlob(peekable));

          case 16:
            peekable.push(value); // (Async)Iterable<Number>

            if (!Number.isInteger(value)) {
              _context2.next = 26;
              break;
            }

            _context2.t0 = Blob;
            _context2.t1 = Uint8Array;
            _context2.next = 22;
            return all(peekable);

          case 22:
            _context2.t2 = _context2.sent;
            _context2.t3 = _context2.t1.from.call(_context2.t1, _context2.t2);
            _context2.t4 = [_context2.t3];
            return _context2.abrupt("return", new _context2.t0(_context2.t4));

          case 26:
            if (!(isBytes(value) || typeof value === 'string' || value instanceof String)) {
              _context2.next = 28;
              break;
            }

            return _context2.abrupt("return", itToBlob(peekable));

          case 28:
            throw errCode(new Error("Unexpected input: ".concat(input)), 'ERR_UNEXPECTED_INPUT');

          case 29:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee);
  }));
  return _toBlob.apply(this, arguments);
}

function itToBlob(stream) {
  var parts, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, chunk;

  return _regeneratorRuntime.async(function itToBlob$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          parts = [];
          _iteratorAbruptCompletion = false;
          _didIteratorError = false;
          _context.prev = 3;
          _iterator = _asyncIterator(stream);

        case 5:
          _context.next = 7;
          return _regeneratorRuntime.awrap(_iterator.next());

        case 7:
          if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
            _context.next = 13;
            break;
          }

          chunk = _step.value;
          parts.push(chunk);

        case 10:
          _iteratorAbruptCompletion = false;
          _context.next = 5;
          break;

        case 13:
          _context.next = 19;
          break;

        case 15:
          _context.prev = 15;
          _context.t0 = _context["catch"](3);
          _didIteratorError = true;
          _iteratorError = _context.t0;

        case 19:
          _context.prev = 19;
          _context.prev = 20;

          if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
            _context.next = 24;
            break;
          }

          _context.next = 24;
          return _regeneratorRuntime.awrap(_iterator.return());

        case 24:
          _context.prev = 24;

          if (!_didIteratorError) {
            _context.next = 27;
            break;
          }

          throw _iteratorError;

        case 27:
          return _context.finish(24);

        case 28:
          return _context.finish(19);

        case 29:
          return _context.abrupt("return", new Blob(parts));

        case 30:
        case "end":
          return _context.stop();
      }
    }
  }, null, null, [[3, 15, 19, 29], [20,, 24, 28]], Promise);
}

module.exports = toBlob;